import React from 'react';

type AxiosInterSeptorProviderProps = {
  children: React.ReactNode;
};

const AxiosInterSeptorProvider = ({
  children,
}: AxiosInterSeptorProviderProps) => {
  return <>{children}</>;
};

export default AxiosInterSeptorProvider;
